import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";


export const FormPaper = styled(Paper)(({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            marginLeft: 0,
            marginRight: 0,
            padding: theme.spacing(1),
            boxSizing: 'border-box',
            borderRadius: 0,
            overflowX: 'hidden',
        },
        [theme.breakpoints.up('sm')]: {
            width: '440px',
            padding: theme.spacing(3),
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5),
            marginLeft: "auto",
            marginRight: "auto",
        },

}));
